import { IconButtonT1 } from "Components/Common/Button/index";
import {
  FlexWrapperT1,
  FlexWrapperT5,
} from "Components/Common/Wrapper/FlexWrapper";
import React, { Fragment } from "react";
import { ReactComponent as ArrowOutline } from "Icons/ArrowOutline.svg";
const PaginationButtons = (props) => {

  const {handleOnClickNextPage , handleOnClickPreviousPage} = props;
  return (
    <Fragment>
      <FlexWrapperT5>
        <FlexWrapperT1>
          <IconButtonT1 onClick={handleOnClickPreviousPage}>
            <ArrowOutline 
            //  fill={"#6F7C8C"} 
             fill={"#528AEA"}
             width={"24px"}
             />
          </IconButtonT1>
          <IconButtonT1 onClick={handleOnClickNextPage}>
            <ArrowOutline
              fill={"#528AEA"}
              width={"24px"}
              transform="rotate(180)"
            />
          </IconButtonT1>
        </FlexWrapperT1>
      </FlexWrapperT5>
    </Fragment>
  );
};

export default PaginationButtons;
